import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ShowcasePageBlockCtaDto } from './ShowcasePageBlockCtaDto'
import { PageBlockTextAlignment } from './Enums'
/**
* Class ShowcasePageBlockCarouselSlideDto
*  Слайд карусели на витрине.
*/
export class ShowcasePageBlockCarouselSlideDto extends ActiveModel {

  /**
  * order
  * Порядок в карусели.  */
  @ActiveField(0)
  order: number = 0


/**
  * desktopImageId
  * Изображение desktop (обязательно для публикации).
  */
  @ActiveField('')
  desktopImageId: string = ''


/**
  * tabletImageId
  * Изображение tablet; fallback на desktop.
  */
  @ActiveField()
  tabletImageId?: null | string


/**
  * mobileImageId
  * Изображение mobile; fallback на tablet, затем desktop.
  */
  @ActiveField()
  mobileImageId?: null | string


/**
  * title
  * Заголовок слайда.
  */
  @ActiveField('')
  title: string = ''


/**
  * subtitle
  * Подзаголовок.
  */
  @ActiveField()
  subtitle?: null | string


  /**
  * textAlignment
  * словарь значений публикуется под именем `Domain.Entities.PageBlocks.PageBlockTextAlignment`  *   * Выравнивание текстового блока.  *   * - `Left` Слева  * - `Center` По центру  * - `Right` Справа  *   */
  @ActiveField(PageBlockTextAlignment.LEFT)
  textAlignment: PageBlockTextAlignment = PageBlockTextAlignment.LEFT


  /**
  * cta
  * Опциональная кнопка / ссылка.  */
  @ActiveField({
    factory: [ShowcasePageBlockCtaDto, () => undefined]
  })
  cta?: null | ShowcasePageBlockCtaDto
}
